var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00059 9.14286C10.5253 9.14286 12.572 7.09616 12.572 4.57143L12.5718 4.52373C11.271 4.48867 10.0871 3.98349 9.18459 3.17304C8.24863 4.01353 7.01003 4.52571 5.65234 4.52571C4.87062 4.52571 4.12734 4.35574 3.45852 4.05045C3.43913 4.22142 3.42916 4.39526 3.42916 4.57143C3.42916 7.09616 5.47586 9.14286 8.00059 9.14286ZM9.61238 1.98459C10.3098 2.77206 11.3003 3.29137 12.4131 3.37187C11.8861 1.42902 10.1102 0 8.00059 0C6.05986 0 4.40159 1.20936 3.73827 2.91558C4.3103 3.21397 4.96081 3.38286 5.65234 3.38286C6.88784 3.38286 7.99652 2.84307 8.75681 1.98461C8.86527 1.86214 9.02101 1.79202 9.18459 1.79202C9.34818 1.79202 9.50392 1.86214 9.61238 1.98459ZM0.585756 15.277C1.77468 12.3498 4.64666 10.2857 8.00072 10.2857C11.3548 10.2857 14.2268 12.3498 15.4157 15.277C15.5596 15.6312 15.2854 16 14.9031 16H1.09829C0.716034 16 0.441911 15.6312 0.585756 15.277Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalAccountIcon);
export default __webpack_public_path__ + "static/media/personalAccountIcon.fa4259678d19fc390dc1c476236c2b92.svg";
export { ForwardRef as ReactComponent };